import { ScoringBand } from '@@types/api.types';
import { cn } from '@lib/utils';
import { type FC } from 'react';
import { formatDashboardScore, scoreFromBand } from './meia-p4-run-cases.util';
import { getScoringBandTone } from './meia-scoring-band.util';

type MeiaMissionThreadVerdictScoreProps = {
  band?: ScoringBand | null;
  score?: number | null;
};

export const MeiaMissionThreadVerdictScore: FC<MeiaMissionThreadVerdictScoreProps> = (props) => {
  const { band, score } = props;
  const resolvedScore = score ?? scoreFromBand(band);
  const scoreLabel = resolvedScore === null ? '-' : formatDashboardScore(resolvedScore);
  const tone = getScoringBandTone(band);

  return (
    <span
      className={cn(
        'inline-flex h-8 min-w-12 shrink-0 items-center justify-center rounded-md border px-2',
        tone.borderClass,
        tone.bgClass,
        tone.textClass,
      )}
    >
      <span className="font-mono text-sm font-bold leading-none">{scoreLabel}</span>
    </span>
  );
};
